export const PERSONAL_CABINET_ROLE = 'employee_self_service'
export const PERSONAL_CABINET_OVERVIEW = 'personal-cabinet-overview'

const PERSONAL_CABINET_ROUTE_PREFIX = 'personal-cabinet'
const PERSONAL_CABINET_ENTRY_ROUTE = 'employee-personal-cabinet'
const INDEX_PAGE_KEY = 'indexPageMobile'

const WORKSPACE_ROUTES = [
  { roles: ['general_manager', 'driver'], route: 'transfers-fuel-receipts' },
  { roles: ['operations_manager', 'operations_supervisor'], route: 'finance-payments' },
  { roles: ['hotel_reception', 'hotel_reservations'], route: 'pos-transactions' },
]
const AVAILABLE_WORKSPACE_ROUTES = new Set([
  'transfers-fuel-receipts',
  'finance-payments',
  'authorization-forms',
  'pos-transactions',
])

export function isPersonalCabinetRoute(route) {
  const routeName = typeof route === 'string' ? route : route?.name
  return Boolean(routeName && (
    routeName === PERSONAL_CABINET_ENTRY_ROUTE ||
    routeName.startsWith(PERSONAL_CABINET_ROUTE_PREFIX)
  ))
}

export function getIndexPageMobile(groups = []) {
  return localStorage.getItem(INDEX_PAGE_KEY) ||
    groups.find(group => group.index_page_mobile)?.index_page_mobile ||
    null
}

export function normalizeGroups(groups = []) {
  return groups.map(group => typeof group === 'string' ? { code: group } : group)
}

export function getWorkspacePageMobile(groups = []) {
  const normalizedGroups = normalizeGroups(groups)
  const savedRoute = localStorage.getItem(INDEX_PAGE_KEY)
  if (AVAILABLE_WORKSPACE_ROUTES.has(savedRoute)) return savedRoute

  const groupRoute = normalizedGroups
    .filter(group => group.code !== PERSONAL_CABINET_ROLE)
    .map(group => group.index_page_mobile)
    .find(route => AVAILABLE_WORKSPACE_ROUTES.has(route))
  if (groupRoute) return groupRoute

  const roleCodes = normalizedGroups.map(group => group.code)
  return WORKSPACE_ROUTES.find(item => item.roles.some(role => roleCodes.includes(role)))?.route || null
}

export function setIndexPageMobile(routeName) {
  if (routeName) localStorage.setItem(INDEX_PAGE_KEY, routeName)
}

export function hasRole(groups = [], roleCode) {
  return groups.some(group => (typeof group === 'string' ? group : group.code) === roleCode)
}
